module.exports = __webpack_public_path__ + "media/images/pc/special_reports/icon_flower-80941f510b63dba0b272a3e53c9b491d.png";